/* Copyright 2016-2021
   Kabandy
   Author: Cedric Hoarau
 */

import { IIdsMapping } from ".";

export module BoardCellDataModel {
    export interface ICell {
        userId: string;
        projectId: string;
        boardId: string;
        valueId: string;
        propertyId: string;
        propertyType: EPropertyType;
    }
    export interface ICopyInfo {
        userId: string;
        projectId: string;
        boardId: string;
        statusId: string;
        valueIdSrc: string;
        valueIdDest: string;
        propertyType: EPropertyType;
    }

    export interface IUpdateInfo {
        userId: string;
        projectId: string;
        boardId: string;
        statusId: string;
        valueIdDest: string;
        propertyType: EPropertyType;
        quantityIdSrc: string;
        modelgroupId?: string; // to be able to specify modelgroup
        customPropertyStorageId?: string; // to be able to specify custom properties
        modelIds?: string[]; // to be able to specify models
        modelIdsMapping?: IIdsMapping; // to be able to specify models
    }

    // TODO: mutualize with BoardUtils/BoardConfig.ts const PropertyType
    export enum EPropertyType {
        ParameterName = "parameterName",
        PropertyName = "propertyName",
        Comment = "comment",
        Check = "check",
        Assignee = "assignee",
        Currency = "currency",
        Document = "document",
        List = "list",
        Note = "note",
        Formula = "formula",
        Status = "status",
        Quantity = "quantity",
        Text = "text",
        Viewpoint = "viewpoint",
        Date = "date",
        Timeline = "timeline",
        QuantityRule = "quantity-rule"
    }

    export enum EParameterLevel {
        Section = "section",
        Group = "group",
        Item =  "item",
        Property =  "property",
        Board =  "board"
    };

    export const BoardCellQuantityCreationInfosFilename: string = "board-cell-quantity-creation-infos.json";
}
